import { FaClock, FaMapMarkerAlt, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaUserCog, FaTshirt, FaBroom, FaCut, FaLeaf } from 'react-icons/fa';
import { FaSprayCanSparkles } from 'react-icons/fa6';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'regular laundry':
      return <FaSprayCanSparkles />; // Sparkles icon

    case 'dry cleaning':
      return <FaTshirt />; // T-shirt icon

    case 'stain removal':
      return <FaBroom />; // Broom icon

    case 'fabric alterations':
      return <FaCut />; // Scissors icon

    case 'express service':
      return <FaClock />; // Clock icon

    case 'eco-friendly cleaning':
      return <FaLeaf />; // Leaf icon


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leaddesigner':
      return <FaUserCog />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Envelope icon

    default: 
      return null; // Return null if no matching icon is found
  }

};